export const defaultValuesForProblematicKeys = {
    linkHighlightTextDecoration: 'none',
    linkHighlightTextDecorationHover: 'none',
    linkHighlightTextDecorationActive: 'none',
    boxShadow: '0 4px 9px 3px rgba(0, 0, 0, 0.3)',
    boxShadowStickyElements: '0 0 14px 0 rgba(0, 0, 0, 0.25)',
    inputColor: '#404247',
    inputColorDisabled: '#ADB1B8'
};


// WEBPACK FOOTER //
// ./src/constants/DefaultValuesForProblematicKeys.js